import { useRoutes } from 'react-router-dom';

import { SELLER_ROUTES } from './seller.routes';
import { NewRoutesWrapperArrayType, normaliseContainerRoutes } from './utils';

export const COMBINED_APP_ROUTE_TYPES: NewRoutesWrapperArrayType = [
  ...SELLER_ROUTES,
] as const satisfies NewRoutesWrapperArrayType;

export const AppRoutes = () => {
  return useRoutes(normaliseContainerRoutes(COMBINED_APP_ROUTE_TYPES));
};
